import { devtools } from 'zustand/middleware';
/**
 * Adds Redux devtools.
 * https://github.com/pmndrs/zustand#redux-devtools
 */
export function addDevtool(creator) {
    return devtools(creator, {
        name: 'FWN Player',
    });
}
/**
 * a livestream fresh from BE will have multiple trivia giveaway entities
 * depending on the current mode of the trivia giveaway (question, answer, giveaway)
 * the interaction will also not have the show_answers field ever on BE
 * so we need to massage the entities and the interaction based on which entities
 * are currently present
 */
export function normalizeTriviaGiveawayModes(liveStream) {
    // remove from entity. We only care about entities.
    if (liveStream.highlighted_entity?.entity_type?.startsWith('trivia_giveaway')) {
        liveStream.highlighted_entity = null;
    }
    // order of modes
    const triviaGiveawayModes = [
        'trivia_giveaway_questions',
        'trivia_giveaway_answers',
        'trivia_giveaway',
    ];
    const nonTGEntities = liveStream.highlighted_entities?.filter((e) => !e?.entity_type?.startsWith('trivia_giveaway')) ?? [];
    // get all trivia giveaway entities
    // sort them by the order of the modes
    // first one is the current mode
    const tgEntities = liveStream.highlighted_entities
        ?.filter((e) => e?.entity_type?.startsWith('trivia_giveaway'))
        .sort((a, b) => {
        return triviaGiveawayModes.indexOf(a?.entity_type ?? '') >
            triviaGiveawayModes.indexOf(b?.entity_type ?? '')
            ? -1
            : 1;
    });
    if (tgEntities && tgEntities.length) {
        // if a trivia giveaway exists, we only want the one with the highest mode
        liveStream.highlighted_entities = [...nonTGEntities, tgEntities[0]];
        // if the current mode is answers, update the corresponding interaction
        // to show the answers
        if (tgEntities[0].entity_type === 'trivia_giveaway_answers') {
            const tgInteraction = liveStream.interactions.find((i) => {
                return i.id === tgEntities[0].entity_id;
            });
            if (tgInteraction) {
                tgInteraction.show_answers = true;
            }
        }
        else if (tgEntities[0].entity_type === 'trivia_giveaway') {
            const tgInteraction = liveStream.interactions.find((i) => {
                return i.id === tgEntities[0].entity_id;
            });
            if (tgInteraction) {
                tgInteraction.winners = tgEntities[0].winners;
            }
        }
    }
    //
    return liveStream;
}
